<template>
  <div class="consult-index-banner-box">
    <!-- 使用oss的高斯模糊 -->
    <div class="consult-index-banner" v-if="showSwiper">
      <div class="swiper-banner-box">
        <div v-swiper:mySwiper="swiperOption">
          <div class="swiper-wrapper">
            <!-- 咨询师-视频 -->
            <template v-if="talkVideoInfo.talk && talkVideoInfo.talk.length">
              <div
                class="swiper-slide _box"
                v-for="(item, index) in talkVideoInfo.talk"
                :key="index"
              >
                <img
                  v-if="parsedAvatar(item.video_cover)"
                  class="bg-mask"
                  :src="parsedAvatar(item.video_cover)"
                  alt=""
                />
                <div class="before-mask"></div>
                <img
                  :src="item.video_cover"
                  alt=""
                  class="video-cover"
                  data-type="video"
                  :data-index="index"
                />
                <img
                  src="~images/platform/homepage/ic-play.png"
                  alt=""
                  class="video-paly-btn"
                  data-type="video"
                  :data-index="index"
                />
              </div>
            </template>
            <!-- 咨询师-相册 -->
            <template v-if="talkVideoInfo.album && talkVideoInfo.album.length">
              <div
                class="swiper-slide _box"
                v-for="(v, i) in talkVideoInfo.album"
                :key="v"
              >
                <img
                  v-if="parsedAvatar(v)"
                  class="bg-mask"
                  :src="parsedAvatar(v)"
                  alt=""
                />
                <div class="before-mask"></div>
                <div>
                  <img
                    :src="v"
                    alt=""
                    class="video-cover"
                    data-type="img"
                    :data-index="i"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        class="swiper-pagination pagination-banner"
        :class="{ abTestV3_5 }"
        slot="pagination"
      ></div>
      <playVideo
        :show="showVideo"
        :videoInfo="videoInfo"
        @close="showVideo = false"
      />
    </div>
    <div
      class="consult-index-banner"
      v-else-if="isConsultTeacher || isQingtingTeacher"
    >
      <img v-if="parsedAvatars" class="bg-mask" :src="parsedAvatars" alt="" />
      <div class="before-mask"></div>
      <img
        :src="basicInfo.avatar | imgZip(400)"
        alt=""
        class="teacher-avatar"
      />
    </div>
    <div class="consult-index-banner consult-index-banner-user" v-else>
      <img
        src="~images/platform/homepage/user-bg.png"
        alt=""
        class="banner-img"
      />
    </div>
    <div v-if="isConsultTeacher && abTestV3_5" class="city-wrap">
      <city />
    </div>
  </div>
</template>
<script>
import playVideo from './playVideo.vue'
import { mapGetters } from 'vuex'
import city from 'component/platform/homepage/common/city.vue'

export default {
  components: {
    playVideo,
    city
  },
  props: {
    abTestV3_5: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      videoInfo: null,
      showVideo: false,
      swiperOption: {
        loop: true,
        autoplay: false,
        centeredSlides: true,
        pagination: {
          el: '.pagination-banner',
          type: 'fraction'
        },
        on: {
          click: e => {
            let { type, index } = e.target.dataset
            let item = {}
            if (type === 'video') {
              item = this.talkVideoInfo.talk[index]
              this.handlePlay(item, index)
            } else if (type === 'img') {
              item = this.talkVideoInfo.album[index]
              this.handlePicture(index)
            }
            console.log(item)
          }
        }
      }
    }
  },
  mounted() {},
  methods: {
    handlePlay(item, index) {
      this.videoInfo = item
      this.showVideo = true
      this.handleTeack('视频', index)
    },
    handlePicture(i) {
      this.handleTeack('相册', i)
      this.$emit('showImgViewer', +i + 1)
    },
    parsedAvatar(imgUrl) {
      if (imgUrl) {
        return (
          imgUrl.split(/(!\d+)?\?/)[0] +
          `?x-oss-process=image/resize,w_200/blur,r_30,s_30`
        )
      }
      return ''
    },
    handleTeack(name, index) {
      this.$trackEvent('newprofilepages_above_click', {
        content_type: name || '',
        item_location: +index + 1
      })
    }
  },
  computed: {
    ...mapGetters({
      isConsultTeacher: 'homepage/isConsultTeacher',
      isQingtingTeacher: 'homepage/isQingtingTeacher'
    }),
    talkVideoInfo() {
      return this.$store.state.homepage.talkVideoInfo
    },
    showSwiper() {
      const { album, talk } = this.talkVideoInfo
      return (album && album.length) || (talk && talk.length)
    },
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    parsedAvatars() {
      const { avatar } = this.basicInfo
      if (avatar) {
        return (
          avatar.split(/(!\d+)?\?/)[0] +
          `?x-oss-process=image/resize,w_200/blur,r_30,s_30`
        )
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
.consult-index-banner-box {
  position: relative;
  .bg-mask {
    width: 10rem;
    height: 422px;
    object-fit: cover;
    position: absolute;
    z-index: -3;
    top: 0;
    left: 50%;
    margin-left: -5rem;
    // background: #a4a4a4;
    opacity: 0.6;
    object-fit: cover;
  }
  // 加多一层透明背景
  .before-mask {
    background: rgba(164, 164, 164, 1);
    position: absolute;
    width: 10rem;
    margin-left: -5rem;
    left: 50%;
    top: 0;
    height: 422px;
    z-index: -4;
  }
}
.consult-index-banner {
  position: relative;
  height: 422px;
  .video-cover {
    max-width: 10rem;
    width: auto;
    height: 422px;
    margin: 0 auto;
  }
  .video-paly-btn {
    width: 86px;
    height: 86px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .pagination-banner {
    position: absolute;
    bottom: 40px;
    right: 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    background: rgba(33, 37, 45, 0.6);
    border-radius: 13px;
    backdrop-filter: blur(4.023px);
    font-size: 20px;
    color: #fff;
    font-family: Helvetica;
    width: 54px;
  }
  .swiper-pagination-fraction {
    right: 20px !important;
    left: auto;
    &.abTestV3_5 {
      top: 20px;
      bottom: auto !important;
    }
  }
  .teacher-avatar {
    max-width: 10rem;
    width: auto;
    height: 422px;
    margin: 0 auto;
  }
}
.consult-index-banner-user {
  height: 340px;
  .banner-img {
    width: 10rem;
    height: 340px;
  }
}
.city-wrap {
  position: absolute;
  padding: 8px 14px 8px 12px;
  right: 20px;
  bottom: 54px;
  background: rgba(33, 37, 45, 0.6);
  border-radius: 19px;
  /deep/ .icon-dingwei1 {
    color: #bcc2cf;
  }
  /deep/ .city {
    color: #fff;
  }
}
</style>
